<template>
  <TileDataContent
    :fids="fids"
    :forecast-label="forecastLabel"
    :dataset="dataset"
    :data-by-id="dataById"
  >
    <template #content-header>
      <TileDataContentHeader>
        <template #second-column>
          <b> {{ $t('components.map.tiles.EuropeForecast.forecastedChargingPoints') }} </b>
        </template>
      </TileDataContentHeader>
    </template>

    <template #content>
      <TileDataContentGroupThreeColumn>
        <TileDataContentRowThreeColumn>
          <template #first-column>
            {{ $t('components.map.tiles.ElaadForecast.semipublic') }}
          </template>

          <template #second-column>
            {{ formatNumber(laadpuntenSemiPubliek()) }}
          </template>
        </TileDataContentRowThreeColumn>
        <TileDataContentRowThreeColumn>
          <template #first-column>
            {{ $t('components.map.tiles.EuropeForecast.home') }}
          </template>

          <template #second-column>
            {{ formatNumber(laadpuntenThuis()) }}
          </template>
        </TileDataContentRowThreeColumn>
      </TileDataContentGroupThreeColumn>
    </template>

    <template #footer>
      ID: {{ fids[0] }}
    </template>
  </TileDataContent>
</template>

<script>
import TileDataContent from '@/components/map/tiles/TileDataContent'
import TiledataMixin from '@/mixins/map/tiledata-mixin'
import TileDataContentHeader from '@/components/map/tiles/TileDataContentHeader'
import TileDataContentRowThreeColumn from '@/components/map/tiles/TileDataContentRowThreeColumn'
import TileDataContentGroupThreeColumn from '@/components/map/tiles/TileDataContentGroupThreeColumn'

export default {
    name: 'TileDataCountryPrognose',
    components: {
        TileDataContentRowThreeColumn,
        TileDataContentHeader,
        TileDataContent,
        TileDataContentGroupThreeColumn,
    },
    mixins: [TiledataMixin],
    methods: {

        // safe getter for raw numeric value from dataById for the first fid
        getRaw(field) {
            const fid = this.fids && this.fids[0]
            if (!fid || !this.dataById || !this.dataById[fid]) return 0
            const val = this.dataById[fid][field]
            const num = Number(val)
            return isNaN(num) ? 0 : num
        },

        laadpuntenThuis() {
            const fieldName = 'thuis_per_cell'
            return this.getRaw(fieldName)
        },

        laadpuntenSemiPubliek() {
            const fieldName = 'semi_publiek_per_cell'
            return this.getRaw(fieldName)
        },

        formatNumber(value, decimals = 0) {
            if (decimals === 0) return new Intl.NumberFormat().format(Math.round(value))
            return new Intl.NumberFormat(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value)
        },
    },
}
</script>

<style>
.currentView {
    color: var(--text-muted);
}

.otherView {
    cursor: pointer;
}
</style>
